// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3783":"css/app.6685","9361":"css/admin-app.6685"}[chunkId] + ".css";
};